/* eslint-disable no-loop-func */
import React, { useCallback, useEffect } from "react";
import styleAddNewTaxDeclaration from "./AddNewTaxDeclaration.module.css";
import MainContent from "../../../layouts/maincontent/MainContent";
import { useState } from "react";

import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import DisputeProviderData from "../../../components/taxDispute/disputeProviderData/DisputeProviderData";
import DisputeRequestData from "../../../components/taxDispute/disputeRequestData/DisputeRequestdata";
import {
  getDisputeGovernorates,
  getDisputeReviewer,
  getExploitationType,
  getSubmitterCharacter,
  getTaxDisputeStoreAllLookups,
  getTaxPeriod,
  getTaxTypes,
  getUnderReviewRequestsCount,
} from "../../../adapters/apis/lookups/lookups";
import { getUser } from "../../../adapters/apis/auth/auth";
import moment from "moment";
import { store_dispute_request } from "../../../adapters/apis/taxDispute/save";
import { get } from "../../../adapters/xhr/api";

function AddNewTaxDispute() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [govs, setGovs] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);
  const [exploitationTypes, setExploitationTypes] = useState([]);
  const [taxPeriods, setTaxPeriods] = useState([]);
  const [disputeReviewrs, setDisputeReviewrs] = useState([]);
  const [underReviewRequestCount, setUnderReviewRequestCount] = useState(0);
  const [taxDisputeSubmitterCharacter, setTaxDisputeSubmitterCharacter] =
    useState([]);

  const [user, setUser] = useState({
    first_name: "",
    father_name: "",
    grandfather_name: "",
    family_name: "",
    email: "",
    phone_number: "",
    nationality: { key: "", value: "" },
    national_id: "",
    passport_number: "",
    building_number: "",
    governorate_id: "",
    district_id: "",
    village_id: "",
    street_id: "",
    street_other: "",
    national_id_file: {},
    passport_number_file: {},
    profile: {},
  });

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified = response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const initializeData = async () => {
    setIsLoading(true);
    try {
      const [lookupRes] = await Promise.all([getTaxDisputeStoreAllLookups()]);

      setGovs(lookupRes.data.data.governorates);
      setTaxTypes(lookupRes.data.data.taxTypes);
      setExploitationTypes(lookupRes.data.data.exploitationTypes);
      setTaxPeriods(lookupRes.data.data.taxPeriods);
      setTaxDisputeSubmitterCharacter(lookupRes.data.data.submitterCharacters);
      setDisputeReviewrs(lookupRes.data.data.disputeReviewers);
      setUser((prev) => ({
        ...prev,
        first_name: lookupRes.data.data.user.profile.first_name,
        father_name: lookupRes.data.data.user.profile.second_name,
        grandfather_name: lookupRes.data.data.user.profile.third_name,
        family_name: lookupRes.data.data.user.profile.fourth_name,
        email: lookupRes.data.data.user.email,
        phone_number: lookupRes.data.data.user.profile.mobile,
        nationality: {
          key: lookupRes.data.data.user.profile.nationality.code,
          value: lookupRes.data.data.user.profile.nationality.name,
        },
        national_id: lookupRes.data.data.user.profile.national_id,
        passport_number: lookupRes.data.data.user.profile.passport_num,
        building_number: lookupRes.data.data.user.profile.real_estate_num,
        governorate_id: lookupRes.data.data.user.profile.governorate_id,
        district_id: lookupRes.data.data.user.profile.district_id,
        village_id: lookupRes.data.data.user.profile.village_id,
        street_id: lookupRes.data.data.user.profile.street_id ?? -1,
        street_other: lookupRes.data.data.user.profile.street_other,
        national_id_file:
          lookupRes.data.data.user.profile.national_id_file?.[0] || null,
        passport_number_file:
          lookupRes.data.data.user.profile.passport_num_file?.[0] || null,
        profile: lookupRes.data.data.user.profile,
      }));

      setIsLoading(false);
    } catch (error) {
      console.error("Initialization error:", error);
    }
  };
  const handleUnderReviewStatusRequestCount = useCallback(async () => {
    setIsLoading(true);
    await getUnderReviewRequestsCount()
      .then((res) => {
        setUnderReviewRequestCount(res.data.data);
        if (res.data.data >= 15) {
          navigate("/tax-dispute-request/list-data", {
            state: {
              countAlertMessage:
                "لقد تجاوزت الحد المسموح لتقديم الطلبات، يرجى الانتظار حتى يتم اتخاذ القرار في أحد طلباتك لكي تتمكن من تقديم طلب جديد",
              countAlert: true,
            },
          });
        } else {
          initializeData();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [navigate]);

  useEffect(() => {
    handleUnderReviewStatusRequestCount();
  }, [handleUnderReviewStatusRequestCount]);

  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section
          className={`${styleAddNewTaxDeclaration["section-content"]} section-content`}
        >
          <div
            className={`${styleAddNewTaxDeclaration.container} container pt-5`}
          >
            <div
              className={`${styleAddNewTaxDeclaration["card-box"]} card-box`}
            >
              <div
                className={`${styleAddNewTaxDeclaration["box-content"]} box-content`}
              >
                {/* <DisputeProviderData /> */}
                <DisputeRequestData
                  user={user}
                  taxDisputeSubmitterCharacter={taxDisputeSubmitterCharacter}
                  govs={govs}
                  taxTypes={taxTypes}
                  exploitationTypes={exploitationTypes}
                  taxPeriods={taxPeriods}
                  disputeReviewrs={disputeReviewrs}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </MainContent>
  );
}

export default AddNewTaxDispute;
